module.exports = __webpack_public_path__ + "static/media/compliant.4649a5a7.png";